// extracted by mini-css-extract-plugin
export var active = "_89-a";
export var activeIndicator = "_89-8";
export var animate = "_89-9";
export var disabled = "_89-b";
export var fullWidth = "_89-2";
export var lg = "_89-7";
export var md = "_89-6";
export var redoButtonTabGroup = "_89-0";
export var sm = "_89-5";
export var tabButton = "_89-3";
export var tabButtonsContainer = "_89-1";
export var xs = "_89-4";